import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ConfigurationPageHeader } from '@modules/configuration/components/ConfigurationPageHeader';
import { configurationPageClass } from '@modules/configuration/components/configurationLayout';
import { Button } from '@components/ui/button/Button';
import { WebhookEndpoint } from '../../models/Webhooks';
import { EndpointCard } from './EndpointCard';
import { EndpointsEmptyState } from './EndpointsEmptyState';

interface EndpointsTableProps {
  endpoints: WebhookEndpoint[];
  isLoading?: boolean;
  onCreateClick: () => void;
  onEdit: (endpoint: WebhookEndpoint) => void;
  onTest: (id: number) => void;
  onToggleStatus: (
    id: number,
    url: WebhookEndpoint['url'],
    event_types: WebhookEndpoint['event_types'],
    currentStatus: WebhookEndpoint['status'],
  ) => void;
  onDelete: (id: number) => void;
}

export function EndpointsTable({
  endpoints,
  onCreateClick,
  onEdit,
  onTest,
  onToggleStatus,
  onDelete,
}: EndpointsTableProps) {
  const { t } = useTranslation('webhooksModule');

  return (
    <div className={`${configurationPageClass} pb-6`}>
      <ConfigurationPageHeader
        title={t('pageTitle')}
        description={t('pageDescription')}
        action={
          endpoints.length > 0 ? (
            <Button variant="primary" size="default" onClick={onCreateClick} data-testid="create-webhook-button">
              <Plus className="h-4 w-4" aria-hidden />
              {t('endpoints.createButton')}
            </Button>
          ) : undefined
        }
      />

      <div className={endpoints.length === 0 ? 'mt-8' : 'mt-8 space-y-2'}>
        {endpoints.length === 0 ? (
          <EndpointsEmptyState onCreateClick={onCreateClick} />
        ) : (
          endpoints.map((endpoint) => (
            <EndpointCard
              key={endpoint.id}
              endpoint={endpoint}
              onEdit={onEdit}
              onTest={onTest}
              onToggleStatus={onToggleStatus}
              onDelete={onDelete}
            />
          ))
        )}
      </div>
    </div>
  );
}
